import type { HeadCell, SortableColumn } from "./types";
import {
  TABLE_BODY_CELL_SX as SHARED_BODY_CELL_SX,
  TABLE_HEADER_CELL_SX as SHARED_HEADER_CELL_SX,
  ROW_NUMBER_WIDTH_PCT as SHARED_ROW_NUMBER_WIDTH_PCT,
} from "../../../../components/ui";

export const COLUMN_COUNT = 12;
/** Index / row-number column share of table width. */
export const ROW_NUMBER_WIDTH_PCT = SHARED_ROW_NUMBER_WIDTH_PCT;

export const CASE_LEVEL_COLUMNS: SortableColumn[] = [
  "caseName",
  "raa",
  "ap",
  "lloExpiration",
  "negotiation",
  "upcomingDeadlines",
];

export const HEAD_CELLS: HeadCell[] = [
  { id: "caseName", label: "Case Name", widthPct: 10 },
  { id: "raa", label: "RAA", widthPct: 5 },
  { id: "ap", label: "AP", widthPct: 5 },
  { id: "lloExpiration", label: "LLO Expiration", widthPct: 8 },
  { id: "negotiation", label: "Negotiation", widthPct: 7 },
  { id: "funnel", label: "Funnel", widthPct: 12 },
  { id: "dueDate", label: "Due Date", widthPct: 7 },
  { id: "taskName", label: "Task", widthPct: 11 },
  { id: "taskAssignee", label: "Task Assignee", widthPct: 8 },
  { id: "description", label: "Description", widthPct: 14 },
  { id: "upcomingDeadlines", label: "Upcoming Deadlines", widthPct: 10 },
];

export const CASE_GROUP_HEAD_CELL_IDS: SortableColumn[] = [
  "caseName",
  "raa",
  "ap",
  "lloExpiration",
  "negotiation",
];

export const CASE_GROUP_END_HEAD_CELL_IDS: SortableColumn[] = ["upcomingDeadlines"];

export const TASK_HEAD_CELL_IDS: SortableColumn[] = [
  "funnel",
  "dueDate",
  "taskName",
  "taskAssignee",
  "description",
];

export const HEAD_CELL_BY_ID = Object.fromEntries(HEAD_CELLS.map((cell) => [cell.id, cell])) as Record<
  SortableColumn,
  HeadCell
>;

export const TABLE_HEADER_CELL_SX = SHARED_HEADER_CELL_SX;

export const TABLE_BODY_CELL_SX = SHARED_BODY_CELL_SX;

export const CASE_GROUP_DIVIDER = {
  borderBottom: "2px solid",
  borderColor: "rgba(15, 23, 42, 0.12)",
};

export const MATTER_GROUP_CELL_SX = {
  ...TABLE_BODY_CELL_SX,
  bgcolor: "rgba(248, 250, 252, 0.95)",
  ...CASE_GROUP_DIVIDER,
  verticalAlign: "top" as const,
};

export const OVERDUE_ROW_BG = "rgba(254, 226, 226, 0.55)";
export const OVERDUE_ROW_HOVER_BG = "rgba(254, 202, 202, 0.7)";

export function getHeadCellSx(headCell: HeadCell) {
  return {
    ...TABLE_HEADER_CELL_SX,
    width: `${headCell.widthPct}%`,
  };
}

export function getBodyCellSx(headCell: HeadCell, extra: Record<string, unknown> = {}) {
  return {
    ...TABLE_BODY_CELL_SX,
    width: `${headCell.widthPct}%`,
    ...extra,
  };
}

export function getRowCellSx(overdue: boolean) {
  return {
    ...TABLE_BODY_CELL_SX,
    ...(overdue ? { bgcolor: OVERDUE_ROW_BG } : {}),
  };
}
